import React from 'react';
import AgeAppropriateTips from '@src/components/age-appropriate-tips';
import Link from '@src/components/link';
import wrapStore from '@src/utils/wrap-store';
import FirstScreenStore from './store';
import cx from 'classnames';
import $$tracker from '@src/tracker';

const styles = require('./index.less');

const FirstScreen = ({ store }) => {
  store.use();
  const endlishDecoration = require('../../images/adBtn/download-sub.png');

  return (
    <div className={cx(styles.firstScreenRoot, store.isActive && styles.firstScreenRootAct)}>
      <div
        className={cx(styles.pageBg, {
          [styles.widthFit]: store.backgroundFitMode === 'width-fit',
          [styles.heightFit]: store.backgroundFitMode === 'height-fit'
        })}
      >
        {/* 背景图片加载完成在显示，不然有一定几率出现闪屏 */}
        <img
          onLoad={() => {
            store.loadedBg = true;
          }}
          style={{ opacity: store.loadedBg === true ? 1 : 0 }}
          alt=""
          src={require('./images/first-screen-bg.jpg')}
        />
      </div>
      <div className={styles.title}>
        <div className={styles.slogan} />
        <div className={styles.subTitle} />
        <div className={styles.playBtn} onClick={store.onVideoPlay} />
      </div>
      <div className={styles.agePrompt}>
        <AgeAppropriateTips gameName={'解限机'} />
      </div>
      <div className={styles.floatGroup}>
        <Link className={styles.float1} onClick={store.openPopMiniModal} />
        <Link className={styles.float2} href="https://mechabreak.seasungames.cn/p/zt/2025/07/02/live/index.html#/" target="_blank" />
      </div>
      <div className={styles.btnGroup}>
        <Link
          className={styles.renderAdBtn}
          href={store.downloadHref}
          download={store.downloadName}
          onClick={() => {
            // 99click 下载埋点： TS=不重复随机数（建议使用当前时间戳）&channel=]当前用户的浏览器是 PC 或者 WAP
            window.__ozEvent('njxjxzdj', `TS=${Date.now()}&channel=PC`);
            $$tracker.clickDownload();
          }}
        >
          <div className={styles.rootWarp}>
            <div data-name="底层border" className={styles.basicBg} />
            <div data-name="顶层背景组" className={styles.topBgGroup}>
              <div data-name="纹理背景" className={styles.texture} />
              <div className={styles.topGroup} />
              <div data-name="左侧光影组" className={styles.leftShadowGroup}>
                <div data-name="bg-1" className={styles.bg1} />
                <div data-name="bg-2" className={styles.bg2} />
                <div data-name="bg-3" className={styles.bg3} />
                <div data-name="bg-4" className={styles.bg4} />
                <div className={styles.hoverGroup}>
                  <div data-name="bg-1" className={styles.bgHover1} />
                  <div data-name="bg-2" className={styles.bgHover2} />
                  <div data-name="bg-3" className={styles.bgHover3} />
                </div>
              </div>
              <div data-name="右侧光影组" className={styles.rightShadowGroup}>
                <div data-name="bg-1" className={styles.bg1} />
                <div data-name="bg-2" className={styles.bg2} />
                <div data-name="bg-3" className={styles.bg3} />
                <div data-name="bg-4" className={styles.bg4} />
                <div className={styles.hoverGroup}>
                  <div data-name="bg-1" className={styles.bgHover1} />
                  <div data-name="bg-2" className={styles.bgHover2} />
                  <div data-name="bg-3" className={styles.bgHover3} />
                </div>
              </div>
              <div data-name="英文装饰" className={styles.decoration}>
                <img alt="" className={styles.left} src={endlishDecoration} />
                <img alt="" className={styles.right} src={endlishDecoration} />
              </div>
              <div data-name="按钮内容" className={styles.btnContent}>
                <Link className={cx(styles.contentBtn)}>
                  下载游戏
                  <div className={styles.iconGroup}>
                    <div className={styles.icon1} />
                    <div className={styles.icon2} />
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </Link>
        <div
          className={styles.renderSignUpBtn}
          onClick={() => {
            window.__ozEvent('njxjajdj', `TS=${Date.now()}&channel=PC`);
            store.openRegisterModal();
            $$tracker.clickRegister('首页');
          }}
        >
          <div className={styles.hoverImg} />
          <div className={styles.text}>快速注册</div>
        </div>
      </div>
    </div>
  );
};

export default wrapStore(FirstScreen, FirstScreenStore);
